module.exports = __webpack_public_path__ + "img/basic_restorejelset_202311.d3141fd1.jpg";